import lowerFirst from 'lodash/lowerFirst';

import { RENDERABLE_NODE_TYPES } from 'ui/workflows/flowchart/shapes/constants/configNames';
import { WORKFLOW_ACTIONS, WORKFLOW_FILTERS, WORKFLOW_NODE_TYPES } from '../base';

export const NODE_TYPES: Record<string, string> = RENDERABLE_NODE_TYPES;

export const NODE_CLASS_TO_TYPE_MAP = {
  [WORKFLOW_ACTIONS.ADD_CONTACT]: NODE_TYPES.ADD_CONTACT,
  [WORKFLOW_ACTIONS.ADD_USER_TO_FB]: NODE_TYPES.ADD_USER_TO_FB,
  [WORKFLOW_ACTIONS.CALL_WEBHOOK]: NODE_TYPES.CALL_WEBHOOK,
  [WORKFLOW_ACTIONS.CHANGE_CONTACT_FIELD]: NODE_TYPES.CHANGE_CONTACT_FIELD,
  [WORKFLOW_ACTIONS.CHANNEL_OPT]: NODE_TYPES.CHANNEL_OPT,
  [WORKFLOW_ACTIONS.DELAY]: NODE_TYPES.DELAY,
  [WORKFLOW_ACTIONS.HOLD]: NODE_TYPES.HOLD,
  [WORKFLOW_ACTIONS.HOLD_UNTIL_REPLY]: NODE_TYPES.HOLD_UNTIL_REPLY,
  [WORKFLOW_ACTIONS.MODIFY_CHANNEL_SUBSCRIPTION]: NODE_TYPES.MODIFY_CHANNEL_SUBSCRIPTION,
  [WORKFLOW_ACTIONS.MODIFY_MESSAGE_TYPE]: NODE_TYPES.MODIFY_MESSAGE_TYPE,
  [WORKFLOW_ACTIONS.REMOVE_CONTACT]: NODE_TYPES.REMOVE_CONTACT,
  [WORKFLOW_ACTIONS.REMOVE_USER_FROM_FB]: NODE_TYPES.REMOVE_USER_FROM_FB,
  [WORKFLOW_ACTIONS.SEND_EMAIL]: NODE_TYPES.SEND_EMAIL,
  [WORKFLOW_ACTIONS.SEND_EMBEDDED]: NODE_TYPES.SEND_EMBEDDED,
  [WORKFLOW_ACTIONS.SEND_IN_APP]: NODE_TYPES.SEND_IN_APP,
  [WORKFLOW_ACTIONS.SEND_PUSH]: NODE_TYPES.SEND_PUSH,
  [WORKFLOW_ACTIONS.SEND_SMS]: NODE_TYPES.SEND_SMS,
  [WORKFLOW_ACTIONS.SEND_WEB_PUSH]: NODE_TYPES.SEND_WEB_PUSH,
  [WORKFLOW_ACTIONS.SEND_WHATSAPP]: NODE_TYPES.SEND_WHATSAPP,
  [WORKFLOW_ACTIONS.TRIGGER_WORKFLOW]: NODE_TYPES.TRIGGER_WORKFLOW,
  [WORKFLOW_ACTIONS.UPDATE_CONTACT_WEBHOOK]: NODE_TYPES.UPDATE_CONTACT_WEBHOOK,
  [WORKFLOW_FILTERS.AB_SPLIT]: NODE_TYPES.AB_SPLIT,
  [WORKFLOW_FILTERS.ATTRIBUTE_SPLIT]: NODE_TYPES.ATTRIBUTE_SPLIT,
  [WORKFLOW_FILTERS.FIELDS_MATCH]: NODE_TYPES.FIELDS_MATCH,
  [WORKFLOW_NODE_TYPES.TRIGGER]: NODE_TYPES.START,
};

/**
 * Reverse of `NODE_CLASS_TO_TYPE_MAP`
 */
export const NODE_TYPE_TO_CLASS_MAP: Record<string, string> = Object.entries(
  NODE_CLASS_TO_TYPE_MAP,
).reduce(
  (acc, [key, value]) => ({
    ...acc,
    [value]: key,
  }),
  {},
);

/**
 * Mappings of:
 * - node types to camel cased node classes
 * - camel cased node classes to node types
 */
export const CAMEL_CASED_CLASS_NODE_TYPE_MAP: Record<string, string> = Object.entries(
  NODE_CLASS_TO_TYPE_MAP,
).reduce((acc, [nodeClass, nodeType]) => {
  const camelCasedNodeClass = lowerFirst(nodeClass);

  return {
    ...acc,
    [nodeType]: camelCasedNodeClass,
    [camelCasedNodeClass]: nodeType,
  };
}, {});

export const ENABLED_NODES = [
  NODE_TYPES.AB_SPLIT,
  NODE_TYPES.ADD_CONTACT,
  NODE_TYPES.ATTRIBUTE_SPLIT,
  NODE_TYPES.CALL_WEBHOOK,
  NODE_TYPES.CHANGE_CONTACT_FIELD,
  NODE_TYPES.DELAY,
  NODE_TYPES.FIELDS_MATCH,
  NODE_TYPES.REMOVE_CONTACT,
  NODE_TYPES.SEND_EMAIL,
  NODE_TYPES.SEND_PUSH,
  NODE_TYPES.SEND_SMS,
  NODE_TYPES.SEND_IN_APP,
  NODE_TYPES.SEND_EMBEDDED,
  NODE_TYPES.SEND_WEB_PUSH,
  NODE_TYPES.SEND_WHATSAPP,
  NODE_TYPES.START,
  NODE_TYPES.TRIGGER_WORKFLOW,
  NODE_TYPES.UPDATE_CONTACT_WEBHOOK,
];

export const NODE_TITLES = {
  [NODE_TYPES.AB_SPLIT]: 'A/B split',
  [NODE_TYPES.ADD_CONTACT]: 'List membership',
  [NODE_TYPES.ADD_USER_TO_FB]: 'Facebook Custom Audience',
  [NODE_TYPES.ATTRIBUTE_SPLIT]: 'Attribute split',
  [NODE_TYPES.CALL_WEBHOOK]: 'Call webhook',
  [NODE_TYPES.CHANGE_CONTACT_FIELD]: 'User profile',
  [NODE_TYPES.CHANNEL_OPT]: 'Channel Optimization',
  [NODE_TYPES.DELAY]: 'Time delay',
  [NODE_TYPES.FIELDS_MATCH]: 'Yes/no split',
  [NODE_TYPES.HOLD]: 'Hold until',
  [NODE_TYPES.HOLD_UNTIL_REPLY]: 'Hold for reply',
  [NODE_TYPES.MODIFY_CHANNEL_SUBSCRIPTION]: 'Subscription preferences',
  [NODE_TYPES.MODIFY_MESSAGE_TYPE]: 'Subscription preferences',
  [NODE_TYPES.NOTE]: '',
  [NODE_TYPES.REMOVE_CONTACT]: 'List membership',
  [NODE_TYPES.REMOVE_USER_FROM_FB]: 'Facebook Custom Audience',
  [NODE_TYPES.SEND_EMAIL]: 'Email',
  [NODE_TYPES.SEND_EMBEDDED]: 'Embedded',
  [NODE_TYPES.SEND_IN_APP]: 'In-app',
  [NODE_TYPES.SEND_PUSH]: 'Push',
  [NODE_TYPES.SEND_SMS]: 'SMS',
  [NODE_TYPES.SEND_WEB_PUSH]: 'Web push',
  [NODE_TYPES.SEND_WHATSAPP]: 'WhatsApp',
  [NODE_TYPES.START]: 'Start',
  [NODE_TYPES.TILESET]: 'Tileset',
  [NODE_TYPES.TRIGGER_WORKFLOW]: 'Send to journey',
  [NODE_TYPES.UPDATE_CONTACT_WEBHOOK]: 'User profile',
};

export const TILE_TITLES = {
  ...NODE_TITLES,
  [NODE_TYPES.ADD_USER_TO_FB]: 'Facebook audiences',
  [NODE_TYPES.REMOVE_USER_FROM_FB]: 'Facebook audiences',
  [NODE_TYPES.NOTE]: 'Note',
};
